import { FC, PropsWithChildren, useEffect } from 'react'

import { usePrevious } from 'peach/hooks'
import { useHistory, useLocation } from 'peach/router'
import { QueryParamsProvider } from 'peach/router/useQueryParams'

import AppProviders from './AppProviders'
import { BetaPagesProvider } from './beta'
import { useActiveEnv } from './stores/env'
import DarkModeProvider from './theme/DarkModeProvider'

type SystemProvidersProps = PropsWithChildren<{}>

const SystemProviders: FC<SystemProvidersProps> = ({ children }) => {
  const activeEnv = useActiveEnv()
  const activeId = activeEnv?.id

  const previousEnvId = usePrevious(activeId)
  const { pathname } = useLocation()

  const history = useHistory()
  // redirect only when switching envs. this prevents getting 403s from ID, etc
  // that exist in one env but not another, but preserves what section
  // the user was in
  useEffect(() => {
    if (activeId && previousEnvId && previousEnvId !== activeId) {
      const [, url] = pathname.split('/')
      history.push(url ? `/${url}` : '/')
    }
  }, [history, pathname, previousEnvId, activeId])

  return (
    <BetaPagesProvider>
      <QueryParamsProvider>
        <AppProviders key={activeId}>
          <DarkModeProvider>{children}</DarkModeProvider>
        </AppProviders>
      </QueryParamsProvider>
    </BetaPagesProvider>
  )
}

export default SystemProviders
